import React from 'react';
export function OpeningSection() {
  return <div className="space-y-6" data-id="element-227">
      <div className="w-full aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-228">
        <img src="https://cdn.shopify.com/s/files/1/0619/1693/8405/files/1_ladysmilinginthesun.png?v=1762469086" alt="Woman in her 60s looking radiant and confident" className="w-full h-full object-cover rounded-lg" data-id="element-229" />
      </div>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-230">
        As a 67-year-old woman, I know the frustration of watching your face
        change in ways you can't control.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-231">
        For years, I invested in the "best" skincare. $200 serums. $150 eye
        creams. Multi-step routines recommended by beauty editors.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-232">
        And for a while, they worked. My skin looked plump, my fine lines
        softened.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-233">
        <b data-id="element-234">But somewhere in my mid-50s, everything changed.</b>
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-235">
        The same products that gave me beautiful results in my 40s did
        absolutely nothing in my 60s.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-236">
        My serums would just sit on my face, greasy and heavy. They'd pill up
        under my makeup. <b data-id="element-237">Nothing seemed to sink in anymore.</b>
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-238">
        My face started to sag. Deep wrinkles appeared seemingly overnight. I
        looked tired all the time, even after a full night's sleep.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-239">
        I wasn't ready to consider injections or surgery.{' '}
        <b data-id="element-240">But I also wasn't ready to just accept "this is aging."</b>
      </p>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-241">
        That's when my dermatologist told me something that changed
        everything...
      </p>
    </div>;
}